<script>
    import { isMobile, scrollState } from "@/utils";
    import { brandHistory } from "@xd/brand-history";
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "BrandMobileNavigation",
        components: { TheSvgIcon },
        data() {
            return {
                selectedIndex: 0,
                isOpened: false,
                isScrollActive: false,
            };
        },
        computed: {
            menu() {
                return Object.values(brandHistory.timeline)
                    .map((value) => {
                        return value.products;
                    })
                    .flat(1);
            },
            selectedTitle() {
                return this.menu[this.selectedIndex].title;
            },
        },
        mounted() {
            if (isMobile(1365)) {
                this.observeNavigation();
            }
        },
        methods: {
            scrollTo(slug) {
                if (slug) {
                    this.isScrollActive = true;
                    setTimeout(() => {
                        this.isScrollActive = false;
                    }, 750);
                    const top =
                        document.querySelector(`#${slug}`).getBoundingClientRect().top +
                        window.scrollY;

                    window.scrollTo({
                        top: top - 30,
                        behavior: "smooth",
                    });
                }
            },
            observeNavigation() {
                const elements = document.querySelectorAll("[data-menu-index]");

                const options = {
                    root: null,
                    threshold: 1,
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !this.isScrollActive) {
                            const { menuIndex } = entry.target.dataset;
                            this.selectedIndex = parseInt(menuIndex);
                        }
                    });
                }, options);

                elements.forEach((element) => observer.observe(element));
            },
            openMenu() {
                this.isOpened = true;
                scrollState.disable();
            },
            closeMenu() {
                this.isOpened = false;
                scrollState.enable();
            },
            clickHandler(index, slug) {
                if (this.selectedIndex === index) {
                    this.closeMenu();
                }

                if (this.isOpened) {
                    this.selectedIndex = index;
                    this.closeMenu();
                    this.scrollTo(slug);
                }
            },
        },
    };
</script>

<template>
    <nav class="brand-mobile-navigation" :class="{ 'is-opened': isOpened }">
        <button class="brand-mobile-navigation__button" @click="openMenu">
            {{ selectedTitle }}
            <the-svg-icon name="arrow" :size-w="12"></the-svg-icon>
        </button>

        <ul class="brand-mobile-navigation__list">
            <li
                class="brand-mobile-navigation__item"
                :class="{ 'is-active': selectedIndex === index && isOpened }"
                v-for="(item, index) in menu"
                :key="index"
            >
                <button
                    class="brand-mobile-navigation__button"
                    :class="{ 'is-opened': isOpened }"
                    @click="clickHandler(index, item.slug)"
                >
                    {{ item.title }}
                    <the-svg-icon name="arrow" :size-w="12"></the-svg-icon>
                </button>
            </li>
        </ul>
    </nav>
</template>

<style lang="scss">
    .brand-mobile-navigation {
        position: relative;
        height: 50px;
        background-color: #fff;
        border-bottom: 1px solid var(--primary-border);
        transition: height 0.2s ease-in;
        &.is-opened {
            .brand-mobile-navigation__list {
                transform: translateY(0);
            }
        }
    }

    .brand-mobile-navigation__list {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        max-height: calc(100vh - 46px);
        background-color: #fff;
        transform: translateY(-100%);
        transition: transform 0.2s ease-in;
        overflow: auto;
    }

    .brand-mobile-navigation__item {
        display: flex;
        justify-content: space-between;
        &.is-active {
            background-color: #f5f6f8;
        }
    }

    .brand-mobile-navigation__button {
        position: relative;
        display: block;
        width: 100%;
        height: 50px;
        padding: 0 32px;
        color: #000;
        font-size: 16px;
        font-weight: 500;
        line-height: 50px;
        text-align: left;
        -webkit-tap-highlight-color: transparent;
        &.is-opened {
            svg {
                transform: rotate(-180deg);
            }
        }
        svg {
            position: absolute;
            top: 19px;
            right: 26px;
            transform: rotate(-90deg);
            transition: transform 0.2s ease-in;
        }
    }

    .brand-mobile-navigation__arrow {
        position: relative;
        flex-shrink: 0;
        @include box(50px);
    }
</style>
